import styles from './Tips.module.scss';
import Slider from '#components/ui/Slider';

type Props = {
  slides: {
    title: string;
    subtitle: string;
  }[];
};

const renderSlide = (slide: { title: string; subtitle: string }) => (
  <div className={styles.tipsTextWrapper}>
    <p className={styles.tipsItemHeadline}>{slide.title}</p>
    <p className={styles.tipsItemDescription}>{slide.subtitle}</p>
  </div>
);

const TipsMobile = ({ slides }: Props) => (
  <Slider
    className={styles.tipsSlider}
    slides={slides}
    renderSlide={renderSlide}
    scrollbar={true}
    slidesPerViewMobile={1}
    slidesPerViewDesktop={1}
  />
);

export default TipsMobile;
